import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'common-card-body',
    templateUrl: './common-card-body.component.html',
    styleUrls: ['./common-card-body.component.scss'],
    standalone: false
})
export class CommonCardBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
